// Is something covering the page right now? A hidden native tab (Android preloads every tab's WebView), the launch
// splash, an open <dialog> or any [aria-modal="true"] that is actually showing (most stay in the DOM, hidden by CSS).
export function isShowing(el) {
  if (typeof el.checkVisibility === "function") {
    return el.checkVisibility({ opacityProperty: true, visibilityProperty: true })
  }
  return el.getClientRects().length > 0 && getComputedStyle(el).opacity !== "0"
}

export function pageCovered(doc = document, win = window) {
  if (win.__toas2tTabHidden === true) return true
  if (doc.getElementById("splash-screen")) return true
  if (doc.querySelector("dialog[open]")) return true
  return [ ...doc.querySelectorAll('[aria-modal="true"]') ].some((el) => isShowing(el))
}

// Android keeps every tab's WebView loaded (and reloads them all after a login): a prompt that opens by itself waits
// until its tab is the one on screen, instead of opening — and counting as seen — out of sight.
export function whenTabShown(callback, win = window) {
  if (win.__toas2tTabHidden !== true) {
    callback()
    return () => {}
  }
  const handler = (event) => {
    if (event.detail?.hidden !== false) return
    win.removeEventListener("native:tab-visibility", handler)
    callback()
  }
  win.addEventListener("native:tab-visibility", handler)
  return () => win.removeEventListener("native:tab-visibility", handler)
}
